import React, {
  useState,
  useEffect,
  useMemo,
  useRef,
  useCallback,
} from 'react';
import { MdNotifications } from 'react-icons/md';
// import { parseISO, formatDistance } from 'date-fns';
// import pt from 'date-fns/locale/pt-BR';

import api from '~/services/api';

import {
  Container,
  Badge,
  NotificationList,
  Scroll,
  Notification,
} from './styles';

export default function Notifications() {
  const [visible, setVisible] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const notifierRef = useRef();

  const hasUnread = useMemo(
    () => !!notifications.find(notification => notification.read === false),
    [notifications]
  );

  const handleToggleVisible = useCallback(() => {
    setVisible(!visible);
  }, [visible]);

  const handleClickOutside = useCallback(
    event => {
      if (
        visible &&
        notifierRef.current &&
        !notifierRef.current.contains(event.target)
      ) {
        handleToggleVisible();
      }
    },
    [handleToggleVisible, visible]
  );

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClickOutside]);

  useEffect(() => {
    async function loadNotifications() {
      try {
        // const response = await api.get('notifications');

        // const data = response.data.map(notification => ({
        //   ...notification,
        //   timeDistance: formatDistance(
        //     parseISO(notification.createdAt),
        //     new Date(),
        //     {
        //       addSuffix: true,
        //       locale: pt,
        //     }
        //   ),
        // }));

        // setNotifications(data);

        setNotifications([]);
      } catch (err) {
        setNotifications([]);
      }
    }

    loadNotifications();
  }, []);

  async function handleMarkAsRead(id) {
    await api.put(`notifications/${id}`);

    setNotifications(
      notifications.map(notification =>
        notification._id === id ? { ...notification, read: true } : notification
      )
    );
  }

  return (
    <Container ref={notifierRef}>
      <Badge onClick={() => handleToggleVisible()} hasUnread={hasUnread}>
        <MdNotifications color="#59c17c" size={20} />
      </Badge>

      <NotificationList visible={visible} ref={notifierRef}>
        <Scroll>
          {notifications.length > 0 ? (
            notifications.map(notification => (
              <Notification key={notification._id} unread={!notification.read}>
                <p>{notification.content}</p>
                <time>{notification.timeDistance}</time>
                {!notification.read && (
                  <button
                    type="button"
                    onClick={() => handleMarkAsRead(notification._id)}
                  >
                    Marcar como lida
                  </button>
                )}
              </Notification>
            ))
          ) : (
            <p>Você ainda não possui nenhuma notificação!</p>
          )}
        </Scroll>
      </NotificationList>
    </Container>
  );
}
